<template>
  <div>
    <div
      v-show="loading"
      style="width: 100%;height: 100%;position: fixed;top: 0px;left: 0px;z-index: 999;background: rgba(0,0,0,.4);"
    >
      <img
        src="../../assets/images/spinner.gif"
        width="100"
        style="position: absolute;top: 50%;left: 50%;width:100px"
      />
    </div>
    <div style="text-align: center;font-size: 20px;">
      <button
        style="width:500px;height:100px;background-color:orange;margin:auto"
        @click="print()"
      >
        طباعة كشف حساب عميل مختصر
        <br />
        {{ client.name }}
      </button>
    </div>
    <div id="printMe" style="display:none">
      <div style="direction:rtl;float:right">
        <p
          style="text-align:center;font-size:22px;font-weight:bold;margin-bottom:15px;text-decoration:underline;"
        >
          كشف حساب عميل مختصر من {{ $route.query.from }} الي
          {{ $route.query.to }}
        </p>
        <div class="row">
          <div class="col-sm-4" style="border-left:1px dotted">
            <div style="float:right;">
              <img
                style="width:100%;height:100px;"
                src="../../../public/images/pharma_logo.jpg"
                alt="Pharma"
              />
            </div>
          </div>
          <div class="col-sm-8">
            <div style="float:right;font-size:17px;text-align:right">
              <p>
                <span style="font-weight:bold;"> كود العميل : </span>
                <span> {{ client.code }} </span>
              </p>
              <p>
                <span style="font-weight:bold;">اسم العميل : </span>
                <span> {{ client.name }} </span>
              </p>
              <p>
                <span style="font-weight:bold;">الرصيد الافتتاحي : </span>
                <span> {{ client.rasid_efttahi }} </span>
              </p>
              <p>
                <span style="font-weight:bold;"> المديونية الحالية : </span>
                <span> {{ the_madionia }} </span>
              </p>
            </div>
          </div>
        </div>
        <hr />
        <p
          style="font-size:20px;font-weight:bold;text-decoration:underline;margin:9px;text-align:center"
        >
          المبيعات
        </p>
        <table
          class="table table-sm table-bordered"
          style="text-align:center"
          v-if="fatworas.length > 0"
        >
          <thead>
            <tr>
              <th scope="col">الكود</th>
              <th scope="col">السعر قبل الخصم</th>
              <th scope="col">الخصم</th>
              <th scope="col">السعر بعد الخصم</th>
              <th scope="col">نوع السداد</th>
              <th scope="col">حالة السداد</th>
              <th scope="col">المندوب</th>
              <th scope="col">التاريخ</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="f in fatworas" :key="f.id">
              <th scope="row">{{ f.code }}</th>
              <td>{{ f.price_before }}</td>
              <td>{{ f.discount }}</td>
              <td>{{ f.price_after }}</td>
              <td>{{ f.sdad_type_name }}</td>
              <td>{{ f.sdad_status }}</td>
              <td>{{ f.emp_sales_response_name }}</td>
              <td>{{ f.created_at.substr(0, 10) }}</td>
            </tr>

            <tr style="font-weight:bold;font-size:15px">
              <td
                style="border: 2px solid black !important;"
                scope="row"
                colspan="2"
              >
                <span>المجموع</span>
              </td>
              <td style="border: 2px solid black !important;;" colspan="4">
                {{ fatwora_price_total }}
              </td>
            </tr>
          </tbody>
        </table>
        <p v-else>لا يوجد فواتير مبيعات</p>

        <hr />
        <p
          style="font-size:20px;font-weight:bold;text-decoration:underline;margin:9px;text-align:center"
        >
          المرتجعات
        </p>
        <table
          class="table table-sm table-bordered"
          style="text-align:center"
          v-if="rebacks.length > 0"
        >
          <thead>
            <tr>
              <th scope="col">الكود</th>
              <th scope="col">السعر قبل الخصم</th>
              <th scope="col">الخصم المرتجع</th>
              <th scope="col">السعر بعد الخصم</th>
              <th scope="col">المندوب</th>
              <th scope="col">التاريخ</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="f in rebacks" :key="f.id">
              <th scope="row">{{ f.code }}</th>
              <td>{{ f.price_before }}</td>
              <td>{{ f.reback_discount }}</td>
              <td>{{ f.price_after }}</td>
              <td>{{ f.emp_sales_response_name }}</td>
              <td>{{ f.created_at.substr(0, 10) }}</td>
            </tr>

            <tr style="font-weight:bold;font-size:15px">
              <td
                style="border: 2px solid black !important;"
                scope="row"
                colspan="2"
              >
                <span>المجموع</span>
              </td>
              <td style="border: 2px solid black !important;;" colspan="4">
                {{ reback_price_total }}
              </td>
            </tr>
          </tbody>
        </table>
        <p v-else>لا يوجد مرتجعات مبيعات</p>
        <hr />
        <p
          style="font-size:20px;font-weight:bold;text-decoration:underline;margin:9px;text-align:center"
        >
          السدادات
        </p>
        <table
          class="table table-sm table-bordered"
          style="text-align:center"
          v-if="sadads.length > 0"
        >
          <thead>
            <tr>
              <th scope="col">الكود</th>
              <th scope="col">المبلغ</th>
              <th scope="col">ملاحظات</th>
              <th scope="col">المندوب</th>
              <th scope="col">فاتورة الخزنة</th>
              <th scope="col">اسم الخزنة</th>
              <th scope="col">التاريخ</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="f in sadads" :key="f.id">
              <th scope="row">{{ f.code }}</th>
              <td>{{ f.money_q }}</td>
              <td>{{ f.note }}</td>
              <td>{{ f.emp_name }}</td>
              <td>{{ f.khazna_fatwora.code }}</td>
              <td>{{ f.khazna.name }}</td>
              <td>{{ f.created_at.substr(0, 10) }}</td>
            </tr>

            <tr style="font-weight:bold;font-size:15px">
              <td
                style="border: 2px solid black !important;"
                scope="row"
                colspan="2"
              >
                <span>المجموع</span>
              </td>
              <td style="border: 2px solid black !important;;" colspan="4">
                {{ sadad_total }}
              </td>
            </tr>
          </tbody>
        </table>
        <p v-else>لا يوجد سدادات</p>

        <hr />
        <p
          style="font-size:20px;font-weight:bold;text-decoration:underline;margin:9px;text-align:center"
        >
          الخصومات
        </p>
        <table
          class="table table-sm table-bordered"
          style="text-align:center"
          v-if="khasms.length > 0"
        >
          <thead>
            <tr>
              <th scope="col">الكود</th>
              <th scope="col">المبلغ</th>
              <th scope="col">ملاحظات</th>
              <th scope="col">نوع الخصم</th>
              <th scope="col">التاريخ</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="f in khasms" :key="f.id">
              <th scope="row">{{ f.code }}</th>
              <td>{{ f.money }}</td>
              <td>{{ f.note }}</td>
              <td>
                {{
                  f.type == "global"
                    ? "خصم علي المديونية"
                    : "خصم من فاتورة معينة"
                }}
              </td>
              <td>{{ f.created_at.substr(0, 10) }}</td>
            </tr>

            <tr style="font-weight:bold;font-size:15px">
              <td
                style="border: 2px solid black !important;"
                scope="row"
                colspan="2"
              >
                <span>المجموع</span>
              </td>
              <td style="border: 2px solid black !important;;" colspan="4">
                {{ fatwora_discount_total }}
              </td>
            </tr>
          </tbody>
        </table>
        <p v-else>لا يوجد خصومات</p>

        <hr />
        <p
          style="font-size:20px;font-weight:bold;text-decoration:underline;margin:9px;text-align:center"
        >
          الشيكات
        </p>
        <table
          class="table table-sm table-bordered"
          style="text-align:center"
          v-if="cheques.length > 0"
        >
          <thead>
            <tr>
              <th scope="col">الصورة</th>
              <th scope="col">الكود</th>
              <th scope="col">قيمة الشيك</th>
              <th scope="col">تاريخ السداد</th>
              <th scope="col">التاريخ</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="f in cheques" :key="f.id">
              <th scope="row">
                <img
                  style="width:100px;height:100px"
                  :src="appUrl + 'cheques/' + f.cheque_photos"
                  alt=""
                />
              </th>
              <th scope="row">{{ f.code }}</th>
              <td>{{ f.value }}</td>
              <td>{{ f.date_sadad }}</td>

              <td>{{ f.created_at.substr(0, 10) }}</td>
            </tr>
          </tbody>
        </table>
        <p v-else>لا يوجد شيكات</p>
        <hr />
        <hr />
        <div
          class="row"
          style="text-align:right;font-weight:bold;font-style:italic"
        >
          <div class="col-6">
            <p>شركة فارما لتوريد وصناعة المستلزمات الطبية</p>
            <p>العنوان : 16 ش ........</p>
            <p>تليفون : 123456789</p>
          </div>
          <div class="col-6">
            <p>فاكس : 123456789</p>
            <p>ايميل : 123456789</p>
            <p>الموقع : 123456789</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { ClientDetailAccount } from "../config/apiRoute.js";
import { appUrl } from "../config/apiConfig.js";
export default {
  data() {
    return {
      loading: true,
      fatworas: [],
      rebacks: [],
      khasms: [],
      sadads: [],
      cheques: [],
      fatwora_price_total: "",
      reback_price_total: "",
      the_madionia: "",
      client: "",
      sadad_total: "",
      fatwora_discount_total: "",
      appUrl: ""
    };
  },
  mounted() {
    this.appUrl = appUrl;
    this.get_data();
  },
  methods: {
    print() {
      this.$htmlToPaper("printMe");
    },
    get_data() {
      var frmData = new FormData();
      frmData.append("client_id", this.$route.query.id);
      frmData.append("date_from", this.$route.query.from);
      frmData.append("date_to", this.$route.query.to);
      ClientDetailAccount(frmData).then(response => {
        response.data.fatworas.length > 0
          ? (this.fatworas = response.data.fatworas)
          : (this.fatworas = []);
        response.data.rebacks.length > 0
          ? (this.rebacks = response.data.rebacks)
          : (this.rebacks = []);
        response.data.khasms.length > 0
          ? (this.khasms = response.data.khasms)
          : (this.khasms = []);
        response.data.sadads.length > 0
          ? (this.sadads = response.data.sadads)
          : (this.sadads = []);
        response.data.cheques.length > 0
          ? (this.cheques = response.data.cheques)
          : (this.cheques = []);
        this.fatwora_price_total = response.data.fatwora_price_total;
        this.fatwora_remain_total = response.data.fatwora_remain_total;
        this.reback_price_total = response.data.reback_price_total;
        this.the_madionia = response.data.madionia;
        this.client = response.data.client;
        this.sadad_total = response.data.sadad_total;
        this.fatwora_discount_total = response.data.fatwora_discount_total;

        this.loading = false;
        setTimeout(() => {
          this.print();
        }, 200);
      });
    }
  }
};
</script>
